import { render, staticRenderFns } from "./myidentity.vue?vue&type=template&id=bbf66c3c&scoped=true&"
import script from "./myidentity.vue?vue&type=script&lang=js&"
export * from "./myidentity.vue?vue&type=script&lang=js&"
import style0 from "./myidentity.vue?vue&type=style&index=0&id=bbf66c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf66c3c",
  null
  
)

export default component.exports